import { P, Predicate } from "breadcommon";
import { useContext } from "react";
import { CategoriesContext } from "../firebaseio/CategoriesContext";

export interface TransactionColumnFilterDisplayCategoryProps {
  predicate: Predicate;
}

export function TransactionColumnFilterDisplayCategory({
  predicate,
}: TransactionColumnFilterDisplayCategoryProps): JSX.Element {
  const categories = useContext(CategoriesContext);

  // Parse the predicate to extract selected category IDs
  // Expected structure: P.Any(P.Equals(P.Field("categoryId"), P.Literal(id1)), P.Equals(..., id2), ...)
  const serializable = predicate.asSerializable();

  const categoryIds: string[] = [];

  if (serializable.name === P.OpName.Any && serializable.args.length > 0) {
    // Multiple categories in P.Any
    for (const arg of serializable.args) {
      if (arg.name === P.OpName.Equals && arg.args.length === 2) {
        const literalOp = arg.args[1];
        if (
          literalOp.name === P.OpName.Literal &&
          typeof literalOp.args[0] === "string"
        ) {
          categoryIds.push(literalOp.args[0]);
        }
      }
    }
  } else if (
    serializable.name === P.OpName.Equals &&
    serializable.args.length === 2
  ) {
    // Single category
    const literalOp = serializable.args[1];
    if (
      literalOp.name === P.OpName.Literal &&
      typeof literalOp.args[0] === "string"
    ) {
      categoryIds.push(literalOp.args[0]);
    }
  }

  // Get category names
  const categoryNames = categoryIds
    .map((id) => categories.get(id)?.name)
    .filter((name): name is string => name !== undefined);

  if (categoryNames.length === 0) {
    return <span>Category filter</span>;
  } else if (categoryNames.length === 1) {
    return <span>Category is {categoryNames[0]}</span>;
  } else if (categoryNames.length <= 3) {
    return <span>Category is {categoryNames.join(", ")}</span>;
  } else {
    return (
      <span>
        Category is {categoryNames.slice(0, 2).join(", ")}, +
        {categoryNames.length - 2} more
      </span>
    );
  }
}
